import React from 'react'
import {Suspense} from 'react'
import {Route, Switch,Redirect} from 'react-router-dom';
import Login from './pages/login';
import Register from "./pages/register";
import BasicLayout from "./layouts/basicLayout";
import WorkDataPane from "./pages/work/workDataPane/view/WorkDataPane";
const DataPane = React.lazy(() => import("./pages/dataPane"));

export default class MainRouter extends React.Component{
    render () {
        return (
            <Suspense  fallback={<div>Loading...</div>}>
                <Switch>
                    <Route exact path="/Login" render={(props) => <Login {...props} />}/>
                    <Route exact path="/register" render={(props) => <Register {...props} />}/>
                    <Route exact path="/" render={(props) => <Redirect to="/dataPane"/>}/>
                    <Route exact path="/dataPane" render={(props) => localStorage.getItem("storeToken") ? <DataPane {...props} /> : <Redirect to="/Login" />}/>
                    <Route exact path="/workDataPane" render={(props) => localStorage.getItem("storeToken") ? <WorkDataPane {...props} /> : <Redirect to="/Login" />}/>
                    <Route exact render={(props) => localStorage.getItem("storeToken") ? <BasicLayout {...props} /> : <Redirect to="/Login" />}/>
                </Switch>
            </Suspense>
        )
    }
};
